module.exports = __webpack_public_path__ + "static/media/logo-saham.dfcd2b1a.svg";